import { render, staticRenderFns } from "./activityScreenN.vue?vue&type=template&id=606a9bd4&scoped=true"
import script from "./activityScreenN.vue?vue&type=script&lang=js"
export * from "./activityScreenN.vue?vue&type=script&lang=js"
import style0 from "./activityScreenN.vue?vue&type=style&index=0&id=606a9bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606a9bd4",
  null
  
)

export default component.exports